import React from "react";
import { DeltaBattleScreen } from "./DeltaBattleScreen";

export const DeltaPlayer3GameScreen = (props) => (
    <DeltaBattleScreen
        {...props}
        characterName="Валерыч"
        attackSignal="valerych_attack"
        healSignal="valerych_heal"
        attackDescription="Пять гвоздей падают сверху после предупреждения. Урон 10."
        healDescription="Водяная пушка стреляет каплями по дуге. Лечение 5."
    />
);
